import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noaccesible',
  templateUrl: './noaccesible.component.html',
  styleUrls: ['./noaccesible.component.css']
})
export class NoaccesibleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goBack(): void {
    window.history.back();
  }

}
